import { Injector } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Notification } from "@app/wapps/notification/notification.model";
import { NotificationParser } from "@app/wapps/notification/notification.parser";
import { UserNotification } from "@api/core.models";
import { format } from "date-fns";
import { NOTIFICATION_TIME_FORMAT, PT_BR_DATE_LOCALE } from "@ui/date-formats";

export class ProcedureFormsNotificationParser extends NotificationParser {
    static Type = "Wapps.Application.Health.Procedures.PreForms.Notification.PreFormResponseNotificationData";
    private _matDialog: MatDialog;

    constructor(injector: Injector) {
        super(injector);
        this._matDialog = injector.get(MatDialog);
    }

    parse(userNotification: UserNotification): Notification {
        let id = userNotification.id;
        let icon = "assignment_turned_in";
        let title = "Resposta de formulário";
        const subtitle = format(new Date(userNotification.notification.creationTime), NOTIFICATION_TIME_FORMAT, {
            locale: PT_BR_DATE_LOCALE,
        });
        return new Notification(id, icon, title, subtitle, userNotification);
    }

    async open(notification: Notification) {
        let data: any = notification.userNotification.notification.data;
        if (!data.responseId) {
            notification.userNotification.notification;
            data = {
                responseId: notification.userNotification.notification.entityId,
            };
        }

        // Loaded on demand: a static import would put the viewer and the agenda proxies in the initial bundle (VS-1954)
        const { AppointmentFormViewerComponent } = await import(
            "@app/wapps/calendar/public/form/appointment-form-viewer.component"
        );
        this._matDialog
            .open(AppointmentFormViewerComponent, {
                panelClass: "appointment-form-viewer-dialog",
                data: data,
            })
            .afterClosed()
            .subscribe();
    }
}
